module.exports = "./img/d821a63a722bdc679261ea85e243f71b.jpg";